import type Selections from '../_steps/enums/SizeStep';
import type WizStepId from '../_steps/enums/WizStepId';
import type { StockStatus } from '../_types/inventoryTypes';
import { useChargerButtonDisabled } from './useChargerButtonDisabled';
import { useRingsButtonDisabled } from './useRingsButtonDisabled';

export interface UseButtonDisabledProps {
  currentStep: WizStepId;
  sizingSelector: Selections;
  size: {
    value: string;
    isValid: boolean;
  };
  isAccessory: boolean;
  isOuraRing4Wizard: boolean;
  stockStatus: StockStatus;
  gen4Enabled: boolean;
}

export const useButtonDisabled = ({
  currentStep,
  sizingSelector,
  size,
  isAccessory,
  isOuraRing4Wizard,
  stockStatus,
  gen4Enabled,
}: UseButtonDisabledProps) => {
  const ringsButtonDisabled = useRingsButtonDisabled({
    currentStep,
    sizingSelector,
    size,
    isAccessory,
    isOuraRing4Wizard,
    stockStatus,
  });
  const chargerButtonDisabled = useChargerButtonDisabled({
    currentStep,
    sizingSelector,
    size,
    isAccessory,
    gen4Enabled,
  });
  return ringsButtonDisabled || !!chargerButtonDisabled;
};
